[
  {
    "code": "JP-23",
    "name": "Aichi"
  },
  {
    "code": "JP-05",
    "name": "Akita"
  },
  {
    "code": "JP-02",
    "name": "Aomori"
  },
  {
    "code": "JP-12",
    "name": "Chiba"
  },
  {
    "code": "JP-38",
    "name": "Ehime"
  },
  {
    "code": "JP-18",
    "name": "Fukui"
  },
  {
    "code": "JP-40",
    "name": "Fukuoka"
  },
  {
    "code": "JP-07",
    "name": "Fukushima"
  },
  {
    "code": "JP-21",
    "name": "Gifu"
  },
  {
    "code": "JP-10",
    "name": "Gunma"
  },
  {
    "code": "JP-34",
    "name": "Hiroshima"
  },
  {
    "code": "JP-01",
    "name": "Hokkaido"
  },
  {
    "code": "JP-28",
    "name": "Hyogo"
  },
  {
    "code": "JP-08",
    "name": "Ibaraki"
  },
  {
    "code": "JP-17",
    "name": "Ishikawa"
  },
  {
    "code": "JP-03",
    "name": "Iwate"
  },
  {
    "code": "JP-37",
    "name": "Kagawa"
  },
  {
    "code": "JP-46",
    "name": "Kagoshima"
  },
  {
    "code": "JP-14",
    "name": "Kanagawa"
  },
  {
    "code": "JP-39",
    "name": "Kochi"
  },
  {
    "code": "JP-43",
    "name": "Kumamoto"
  },
  {
    "code": "JP-26",
    "name": "Kyoto"
  },
  {
    "code": "JP-24",
    "name": "Mie"
  },
  {
    "code": "JP-04",
    "name": "Miyagi"
  },
  {
    "code": "JP-45",
    "name": "Miyazaki"
  },
  {
    "code": "JP-20",
    "name": "Nagano"
  },
  {
    "code": "JP-42",
    "name": "Nagasaki"
  },
  {
    "code": "JP-29",
    "name": "Nara"
  },
  {
    "code": "JP-15",
    "name": "Niigata"
  },
  {
    "code": "JP-44",
    "name": "Oita"
  },
  {
    "code": "JP-33",
    "name": "Okayama"
  },
  {
    "code": "JP-47",
    "name": "Okinawa"
  },
  {
    "code": "JP-27",
    "name": "Osaka"
  },
  {
    "code": "JP-41",
    "name": "Saga"
  },
  {
    "code": "JP-11",
    "name": "Saitama"
  },
  {
    "code": "JP-25",
    "name": "Shiga"
  },
  {
    "code": "JP-32",
    "name": "Shimane"
  },
  {
    "code": "JP-22",
    "name": "Shizuoka"
  },
  {
    "code": "JP-09",
    "name": "Tochigi"
  },
  {
    "code": "JP-36",
    "name": "Tokushima"
  },
  {
    "code": "JP-13",
    "name": "Tokyo"
  },
  {
    "code": "JP-31",
    "name": "Tottori"
  },
  {
    "code": "JP-16",
    "name": "Toyama"
  },
  {
    "code": "JP-30",
    "name": "Wakayama"
  },
  {
    "code": "JP-06",
    "name": "Yamagata"
  },
  {
    "code": "JP-35",
    "name": "Yamaguchi"
  },
  {
    "code": "JP-19",
    "name": "Yamanashi"
  }
]